import React, { useState } from "react";
import "../../App.css";
import "./Application_membership.css";
import FormikComponent from "../React/Formik/FormikComponent";
import FormComponent from "../React/Formik/FormComponent";
import {
	applicationFields,
	initialValues,
	validationSchema,
} from "./MembershipDataSchema";
import { postData } from "../Api/CommonApi";
import { otpVerification } from "../Api/Links";
import { useNavigate } from "react-router-dom";

export const Application_membership = () => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const handleSubmit = (values) => {
		// console.log(values, "onSubmit");
		let body = {
			...values,
			membershipId: values["membershipPeriod"]?.value,
			lacunaInfo: values["lacunaInfo"]?.value,
			// password: atob(password)
		};
		let headerContentType = "application/json";
		setIsLoading(true);
		postData(
			otpVerification,
			body,
			headerContentType,
			(res) => {
				console.log(res.data, "res");
				setIsLoading(false);
				if (res.data.status === "success") {
					navigate("/otpVerification", {
						state: {
							id: res.data.data.id,
							endDate: res.data.data.endDate,
						},
					});
				}
			},
			(err) => {
				console.log(JSON.stringify(err, null, 2));
			}
		);
	};

	return (
		<section className="membership_app_wrapper">
			<div className="container">
				<h2 className="my-5">Apply For Membership</h2>
				<div className="membership-form m-auto  w-75">
					<FormikComponent
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={handleSubmit}
					>
						{applicationFields.map((item, index) => (
							<div class="mb-5 row" key={index}>
								<label
									for={item.name}
									class="col-sm-2 col-form-label"
								>
									{item.label}
								</label>
								<div class="col-sm-10">
									<FormComponent
										type={item.type}
										name={item.name}
										label={item.label}
										options={item.options && item.options}
									/>
								</div>
							</div>
						))}
						<div className="d-flex justifiy-content-end">
							<button
								className="btn btn-pri"
								type="submit"
								disabled={isLoading}
							>
								{isLoading && (
									<i class="fa fa-circle-o-notch fa-spin text-white mr-2"></i>
								)}
								Submit
							</button>
						</div>
					</FormikComponent>
				</div>
			</div>
		</section>
	);
};
